// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"54499dcb","455":"c97bb5ed","977":"d3175c44"}[chunkId] + ".chunk.js";
};